import { v4 as uuid } from 'uuid';

import { ComboboxSuggestions, SuggestionWithIdAndValue } from '../ComboboxTypes';

export default function createSuggestions(
    suggestions: ComboboxSuggestions[],
    currentInputValue: string,
): SuggestionWithIdAndValue[] {
    return suggestions.map((suggestion) => ({
        ...suggestion,
        id: uuid(),
        currentInputValue,
    }));
}
